import { render, staticRenderFns } from "./MoralHistoryPointConvert.vue?vue&type=template&id=24006fc2&scoped=true"
import script from "./MoralHistoryPointConvert.vue?vue&type=script&lang=js"
export * from "./MoralHistoryPointConvert.vue?vue&type=script&lang=js"
import style0 from "./MoralHistoryPointConvert.vue?vue&type=style&index=0&id=24006fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24006fc2",
  null
  
)

export default component.exports